<div class="newUserContainer animateH5">
    <div class="header hdr" *ngIf="userSubscription !== 1 && userSubscription">
        <h5> <span class="animateH5">User Registration</span></h5>
    </div>
    <form [formGroup]="newUserForm">
        <div class="container userFormContainer">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card userDetailsCard" *ngIf=" userSubscription !== 1 && userSubscription">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="userHeading border">User Registration</h4>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Name <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" class="form-control" formControlName="username" name="username"
                                        id="username" placeholder="Enter user name">
                                    <span class="text-danger"
                                        *ngIf="newUserForm.controls['username'].invalid && newUserForm.controls['username'].dirty && newUserForm.hasError('required','username')">
                                        User name is required.
                                    </span>
                                    <span class="text-danger"
                                    *ngIf="newUserForm.controls['username'].invalid && newUserForm.controls['username'].dirty && newUserForm.hasError('pattern','username')">
                                   Enter valid user name.
                                </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Role <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <select type="text" class="form-select" formControlName="role" name="role"
                                        id="role">
                                        <option value="" selected hidden>--select--</option>
                                        <option value="100">Supervisor</option>
                                        <option value="101">User</option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="newUserForm.controls['role'].invalid && newUserForm.controls['role'].dirty && newUserForm.hasError('required','role')">
                                        User role is required.
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel"
                                        [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">Email <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="email" class="form-control" formControlName="email" name="email"
                                        id="email" placeholder="example@gmail.com">
                                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                        <div class="text-danger" *ngIf="f['email'].errors['required']">
                                            Email is required</div>
                                        <div class="text-danger" *ngIf="f['email'].errors['pattern']">Email is not Valid
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel"
                                        [ngClass]="{ 'is-invalid': submitted && f['phonenumber'].errors }">Phone Number
                                        <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <!-- <input type="tel" class="form-control" formControlName="phonenumber"
                                        name="phonenumber" id="phonenumber" placeholder="Enter phone number" ng2TelInput
                                        [ng2TelInputOptions]="{initialCountry: 'in'}" (hasError)="hasError($event)"
                                        (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)"
                                        (countryChange)="onCountryChange($event)"> -->
                                        <input formControlName="phonenumber" id="phonenumber" name="phonenumber"
                                        class="form-control"  #intlInput type="tel"
                                         placeholder="Enter phone number">
                                    <div *ngIf="submitted && f['phonenumber'].errors" class="invalid-feedback">
                                        <div class="text-danger" *ngIf="f['phonenumber'].errors['required']">
                                            Phone number is required</div>
                                        <div class="text-danger" *ngIf="f['phonenumber'].errors['pattern']">Phone number
                                            is not Valid and must contain atleast 10 numbers</div>
                                            <div class="text-danger" *ngIf="f['phonenumber'].errors['maxlength']">Phone number
                                            is not Valid</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-end">
                                <button class="btn btn-light cancelBtn" type="button"
                                    (click)="pressCancel()">Cancel</button>
                                <button class="btn btn-primary updateBtn" type="submit"
                                    [disabled]="newUserForm.dirty && spinner" (click)="onSubmit()">
                                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                        <span class="sr-only">Loading...</span>
                                    </i>Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card userDetailsCard text-center" *ngIf="userSubscription === 1 || !userSubscription">

                        <p class="notification-text">You are using trial account, please subscribe to add new user.</p>
                        <div class="newUserBtnClass text-center">
                            <button class="btn btn-primary updateBtn" type="submit" (click)="goSettings()">Go To
                                Subscription</button>
                            <!-- <button class="btn btn-secondary cancelBtn" type="button" (click)="pressCancel()">Go
                                Back</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>